import React, { useEffect } from "react";
import { Link } from "react-router-dom";

import usePageTitle from "../../../hooks/UsePageTitle";
import checkMaintenanceMode from "../../../MaintenanceModeUtil";

const NotFoundPage = () => {
  usePageTitle("Page Not Found | Alumni");
  useEffect(() => {
    checkMaintenanceMode();
  }, []);

  return (
    <main
      className="ct-bg-primary-500 ct-min-h-screen ct-flex ct-items-center ct-justify-center"
    >
      <div className="ct-w-full">
        <img
          className="ct-block ct-mx-auto ct-mb-4"
          style={{ maxWidth: "400px" }}
          src="nbcu-logo.png"
          alt="The Now Portal logo"
        />
        <div
          className="ct-bg-white ct-mx-auto ct-rounded-sm ct-p-4 ct-flex ct-justify-center ct-items-center ct-w-[60%] sm:ct-w-[80%] ct-min-w-[325px]"
        >
          <div
            className="ct-bg-gold-150 ct-border ct-border-gold-300 ct-rounded-sm ct-px-4 ct-py-2 ct-flex-1"
            role="alert"
          >
            <p className="ct-font-rock ct-font-bold ct-text-honey-800 ct-m-0 ct-text-[16px] ct-text-center">
              Page not found.
            </p>
            <p className="ct-font-rock ct-font-bold ct-text-honey-800 ct-m-0 ct-mt-2 ct-text-[16px] ct-text-center">
              Did you want to{" "}
              <Link to="/" className="ct-text-honey-800 ct-underline">
                login
              </Link>
              {", "}
              <Link to="/register" className="ct-text-honey-800 ct-underline">
                register
              </Link>
              {", or did you "}
              <Link to="/forgot-username" className="ct-text-honey-800 ct-underline">
                forget your username
              </Link>
              ?
            </p>
          </div>
        </div>
      </div>
    </main>
  );
};

export default NotFoundPage;
